import "./AboutContent&CVStyles.css"

function CVContent() {
  return (
    <div className="about">

        <div className="left">

            <h1>SOON</h1>

            {/* <p>Paragraph text</p> */}

                {/* <a href="https://www.amazon.com/Singularity-Near-Humans-Transcend-Biology/dp/0143037889" 
                    target="_blank" 
                    rel="noreferrer" > 
                <button className="btn btn-light"> 
                    Source
                </button></a> */}
        </div>

        <div className="right2">
            {/* <div className="img-container">
                <div className="img-stack top">
                    <img src={DataVizPhoto} className= "img2" alt={DataVizPhoto} />
                </div>
            </div> */}
        </div>
    </div>
  )
}

export default CVContent